import React from 'react'
import Navbar from '../../Navbar';
import Hero from './Hero';
import Team from './Team';
import Footer from '../../Footer';

function AboutPage() {
    return ( 
        <>
            <Hero/>
            <Team/>
            
        </>
     );
}

export default AboutPage ;